import { Flex, FlexProps, Text } from "@mantine/core";
import { FC } from "react";

interface ShipmentDescriptionProps extends FlexProps {
  value?: string | null;
}

const ShipmentDescription: FC<ShipmentDescriptionProps> = ({
  value,
  flex = 1,
  p = 2,
  mih = 24,
  ...flexProps
}) => {
  if (!value) return null;

  return (
    <Flex {...flexProps} flex={flex} p={p} mih={mih}>
      <Text c={"black"} fz={14} fw={300} lh={1}>
        {value}
      </Text>
    </Flex>
  );
};

export default ShipmentDescription;
